/**
 * Created by asiulik on 04.04.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './parketFiltersNav', './parketFiltersContent'], function($, _, EventEmitter, FiltersNav, FiltersContent){

    function ParketFilters(layoutIstance){
        this.layoutIstance = layoutIstance;
        this.filtersNavInstance = new FiltersNav(this.layoutIstance);
        this.filterContentInstance = new FiltersContent();
    }

    ParketFilters.prototype.init = function(){

        this.filtersNavInstance.init();
        this.filterContentInstance.init();

    };

    ParketFilters.prototype.getFiltersModulesInstances = function(){
        return {
            filtersNav: this.filtersNavInstance,
            filtersContent: this.filterContentInstance
        }
    };


    return ParketFilters;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/parketFilters/parketFilters.js